import React, { FC, ReactNode, useContext } from 'react'

import { styled } from '@linaria/react'

import { useBaseDatingSettingsUrl } from 'components/page/Profile/ProfileHooks/useBaseDatingSettingsUrl'
import { StyledWrapperField } from 'components/page/ProfileCommon/ProfileField/ProfileField.styled'
import { ProfileFieldGenericProps } from 'components/page/ProfileCommon/ProfileField/ProfileGreeting/ProfileFieldGeneric.types'
import { SwitchProfileField } from 'components/page/ProfileCommon/ProfileField/SwitchProfileField'
import { ProfileContext } from 'components/page/UserProfile/Context/CreateProfileContext'
import { GenericMenuItemIndex } from 'components/presentational/GenericMenuItemIndex/GenericMenuItemIndex'
import { StyledIconWrapper } from 'components/presentational/GenericMenuItemIndex/GenericMenuItemIndex.styled'
import { IconActiveEditFieldSvg } from 'components/presentational/svg/IconActiveEditFieldSvg'
import { notEmptyArray } from 'functions/array'
import { mergeAllUrls } from 'functions/mergeAllUrls'

export const ProfileFieldGeneric: FC<ProfileFieldGenericProps> = ({
  iconDefault,
  iconActive,
  description,
  ['data-name']: dataName,
  data,
  lexemes,
  showDescriptionIfActive,
  fieldType,
  style,
  onClick,
  ...rest
}) => {
  const { isEditable } = useContext(ProfileContext)
  const isActive = data !== null || notEmptyArray(data as any)
  const link = mergeAllUrls(useBaseDatingSettingsUrl(), dataName!)
  const dataNameChange = isEditable ? `profile-${dataName}-action` : dataName

  const iconItem = (
    <IconSwitch iconDefault={iconDefault} iconActive={iconActive} />
  )

  if (isActive) {
    return (
      <Parent>
        <StyledWrapperField>
          <GenericMenuItemIndex
            to={isEditable ? link : undefined}
            data-name={dataNameChange}
            hideArrow={true}
            control={<IconActiveEditFieldSvg />}
            active={true}
            label={false}
            iconItem={iconItem}
            {...rest}
            style={style}
            onClick={onClick}
          >
            {showDescriptionIfActive && description}
            <SwitchProfileField
              type={fieldType}
              data={data}
              lexemes={lexemes}
            />
          </GenericMenuItemIndex>
        </StyledWrapperField>
      </Parent>
    )
  }

  return (
    <Parent>
      <StyledWrapperField>
        <GenericMenuItemIndex
          to={link}
          data-name={dataName}
          hideArrow={true}
          active={false}
          iconItem={iconItem}
          style={style}
          onClick={onClick}
        >
          {description}
        </GenericMenuItemIndex>
      </StyledWrapperField>
    </Parent>
  )
}

const IconSwitch: FC<{
  iconActive: ReactNode
  iconDefault: ReactNode
}> = ({ iconDefault, iconActive }) => {
  if (iconActive) {
    return <StyledIconWrapper>{iconActive}</StyledIconWrapper>
  }

  if (iconDefault) {
    return <StyledIconWrapper>{iconDefault}</StyledIconWrapper>
  }

  return null
}

const Parent = styled.div`
  display: flex;
  min-width: 0;
  max-width: 100%;
`
